import Fire from '../config/Fire';
import {
	MATCH_FETCH,
	MATCH_FETCH_SUCCESS,
	MATCH_FETCH_FAIL,
	MATCH_TOGGLE_EDIT,
	MATCH_EDIT_SEASONID_CHANGE,
	MATCH_EDIT_POSTID_TEXT_CHANGE,
	MATCH_EDIT_NAME_TEXT_CHANGE,
	MATCH_EDIT_DESC_TEXT_CHANGE,
	MATCH_EDIT_FORMATION_CHANGE,
	MATCH_EDIT_ACTIVE_CHANGE,
	MATCH_UPDATE,
	MATCH_UPDATE_SUCCESS,
	MATCH_UPDATE_FAIL,
	MATCH_NEW,
	MATCH_NEW_SUCCESS,
	MATCH_NEW_FAIL,
	MATCH_DELETE,
	MATCH_DELETE_SUCCESS,
	MATCH_DELETE_FAIL,
	MATCH_EDIT_BONUS_TEXT_CHANGE,
} from './types';

export const matchFetch = season => {
	return dispatch => {
		dispatch({ type: MATCH_FETCH });
		Fire.firestore()
			.collection('seasons')
			.doc(season)
			.collection('matches')
			.get()
			.then(function(querySnapshot) {
				const obj = {};
				let arr = [];
				querySnapshot.forEach(function(doc) {
					arr = [...arr, parseInt(doc.id, 10)];
					let v = {};
					v = doc.data();
					v.readOnly = true;
					v.onChange = doc.data();
					obj[doc.id] = v;
				});
				return dispatch({
					type: MATCH_FETCH_SUCCESS,
					payload: obj,
					listByID: arr.sort((a, b) => a - b),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: MATCH_FETCH_FAIL });
			});
	};
};

export const singleMatchFetch = (season, match) => {
	return dispatch => {
		dispatch({ type: MATCH_FETCH });
		Fire.firestore()
			.collection('seasons')
			.doc(season)
			.collection('matches')
			.doc(match)
			.get()
			.then(function(doc) {
				const obj = {};
				let arr = [];
				if (!doc.exists) {
					return dispatch({
						type: MATCH_FETCH_SUCCESS,
						payload: obj,
						listByID: arr.sort((a, b) => a - b),
					});
				}
				arr = [...arr, parseInt(doc.id, 10)];
				let v = {};
				v = doc.data();
				v.readOnly = true;
				v.onChange = doc.data();
				obj[doc.id] = v;
				return dispatch({
					type: MATCH_FETCH_SUCCESS,
					payload: obj,
					listByID: arr.sort((a, b) => a - b),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				return dispatch({ type: MATCH_FETCH_FAIL });
			});
	};
};

export const matchUpdate = (obj, doc) => {
	return dispatch => {
		dispatch({ type: MATCH_UPDATE, payload: obj });
		Fire.firestore()
			.collection('seasons')
			.doc(obj.season)
			.collection('matches')
			.doc(doc)
			.set(obj, { merge: true })
			.then(function() {
				return dispatch({
					type: MATCH_UPDATE_SUCCESS,
					payload: obj,
					id: parseInt(doc, 10),
				});
			})
			.catch(function(_e) {
				console.log('_error', _e);
				dispatch({
					type: MATCH_UPDATE_FAIL,
					id: parseInt(doc, 10),
					error: true,
					errorText: _e.message,
				});
				setTimeout(function() {
					return dispatch({
						type: MATCH_UPDATE_FAIL,
						id: parseInt(doc, 10),
						error: false,
						errorText: '',
					});
				}, 1500);
			});
	};
};

export const matchNew = obj => {
	return dispatch => {
		dispatch({ type: MATCH_NEW });
		const nn = new Date().getTime();
		Fire.firestore()
			.collection('seasons')
			.doc(obj.season)
			.collection('matches')
			.doc(nn.toString())
			.set(obj, { merge: true })
			.then(function() {
				return dispatch({
					type: MATCH_NEW_SUCCESS,
					payload: obj,
					id: nn,
				});
			})
			.catch(function(_e) {
				console.log('_error', _e);
				dispatch({ type: MATCH_NEW_FAIL, error: true, errorText: _e.message });
				setTimeout(function() {
					return dispatch({ type: MATCH_NEW_FAIL, error: false, errorText: '' });
				}, 1500);
			});
	};
};

export const matchDelete = (doc, season) => {
	return dispatch => {
		dispatch({ type: MATCH_DELETE });
		Fire.firestore()
			.collection('seasons')
			.doc(season)
			.collection('matches')
			.doc(doc)
			.delete()
			.then(function() {
				return dispatch({
					type: MATCH_DELETE_SUCCESS,
					id: parseInt(doc, 10),
				});
			})
			.catch(function(_err) {
				console.log('_error', _err);
				dispatch({
					type: MATCH_DELETE_FAIL,
					id: parseInt(doc, 10),
					error: true,
					errorText: _err.message,
				});
				setTimeout(function() {
					return dispatch({
						type: MATCH_DELETE_FAIL,
						id: parseInt(doc, 10),
						error: false,
						errorText: '',
					});
				}, 1500);
			});
	};
};

export const toggleEdit = i => ({ type: MATCH_TOGGLE_EDIT, id: i });
export const onSeasonIdTextChange = (i, text) => ({
	type: MATCH_EDIT_SEASONID_CHANGE,
	id: i,
	payload: text,
});
export const onPostIdTextChange = (i, text) => ({
	type: MATCH_EDIT_POSTID_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onNameTextChange = (i, text) => ({
	type: MATCH_EDIT_NAME_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onDescTextChange = (i, text) => ({
	type: MATCH_EDIT_DESC_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onBonusTextChange = (i, text) => ({
	type: MATCH_EDIT_BONUS_TEXT_CHANGE,
	id: i,
	payload: text,
});
export const onFormationChange = (i, obj) => ({
	type: MATCH_EDIT_FORMATION_CHANGE,
	id: i,
	payload: obj,
});
export const onActiveChange = (i, text) => ({
	type: MATCH_EDIT_ACTIVE_CHANGE,
	id: i,
	payload: text,
});

export default { matchFetch, toggleEdit, matchUpdate, matchNew, matchDelete };



// WEBPACK FOOTER //
// ./src/actions/MatchActions.js